import { AxiosResponse } from "axios";
import { call, CallEffect, PutEffect, SelectEffect, select } from "@redux-saga/core/effects";
import { getCustomer } from "./functions";
import { Action } from "redux-saga";
import { ReducersTypes } from "@/redux/reducers/Models";
import { automaticApi } from "@/settings/api";
import {
  clearString,
  getFormattedCart,
  getFormattedDeviceFingerPrintID,
} from "@/utils/functions";
import environment from "@/settings/environment";
import { getIp } from "../ip/get";
import resolveLoggedAccount, {
  ResolvedAccount,
} from "../account/resolveLogged";

export interface Fetch {
  visitorId: string;
  callback: (success: boolean, data?: { sqPagamento?: string }) => void;
}

export interface RechargeSavedCardAction {
  type: string;
  payload: Fetch;
}

const uri = "/internalwebapi/v1/payments/credit-card";

export default function* rechargeSavedCard({
  payload,
}: RechargeSavedCardAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);
    const client = customer?.client;

    const resolvedAccount = (yield call(
      resolveLoggedAccount,
      client?.id,
    )) as unknown as ResolvedAccount | null;
    if (!resolvedAccount) {
      yield call(payload.callback, false);
      return;
    }

    const { total, selected } = getFormattedCart({
      debts: customer?.debts!,
      cart: customer?.cart?.filter((item) => item.checked) ?? [],
    });

    const deviceFingerprintID = getFormattedDeviceFingerPrintID(
      payload.visitorId ?? "",
    );

    // @ts-expect-error getIp
    const ip: string = yield call(getIp);

    const body = {
      requestId: customer?.requestId!,
      customerIdentification: resolvedAccount.customerId,
      accountIdentification: resolvedAccount.accountId,
      paymentValue: total,
      licensePlate: customer?.selectedVehicles
        ? customer?.selectedVehicles?.toString()
        : customer?.vehicles?.[0]?.plate,
      tollPassages: selected,
      email: client?.email,
      phoneNumber: clearString(client?.phone!),
      ...(environment.api.prefix !== "qa"
        ? {
            deviceInformation: {
              fingerprintSessionId: deviceFingerprintID,
            },
          }
        : null),
      userIP: ip,
      channel: environment.api.channel,
      companyIdentification: environment.api.companyIdentification,
    };

    const response: AxiosResponse = yield call(automaticApi.post, uri, body);
    const data = response?.data;
    if (data?.idTransaction) {
      yield call(payload.callback, true, { sqPagamento: data?.sqPagamento });
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
